import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

import { TranslatePipe } from '@softline/ui-core';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-artstamm-master-view',
  imports: [CommonModule,
    TranslatePipe],
  templateUrl: './artstamm.master-view.html',
  styleUrls: ['./artstamm.master-view.css'] })
export class ArtstammMasterView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
